import { memo, ReactNode } from "react";
import "./spinner.scss";

interface SpinnerProps {
  className?: string;
  classNameFather?: string;
  children?: ReactNode;
  alternativeChildren?: ReactNode;
  status: boolean;
}

function Spinner(props: SpinnerProps) {
  const { children, className, status, classNameFather, alternativeChildren } = props;
  return (
    <div className={`${classNameFather}`}>
      {status ? (
        <>
          <div className={`spinnerComponent ${className}`}></div>
          {alternativeChildren && <p>{alternativeChildren}</p>}
        </>
      ) : (
        children
      )}
    </div>
  );
}

export default memo(Spinner);
